import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { PrecioControlDetalle } from './components/PrecioControlDetalle';

export default function IndexPrecioControlDetalle() {
    return (
        <>
            <MainContent
                component={<PrecioControlDetalle />}
                titulo='Autorización Precio Control'	
                noBackground
                tableMaxWidth
            />
        </>
    );

};
